/*
 * BreatheFree — "Upgrade to subscription" for one-time cart line items (Recharge).
 *
 * Loaded from theme.liquid as a normal <script src> so it ALWAYS executes, even if
 * the cart markup is injected dynamically. The click listener is bound on `document`
 * in the CAPTURE phase, so it fires regardless of propagation/stopping and works for
 * buttons added to the DOM later (drawer re-renders).
 *
 * IMPORTANT: after applying the selling plan we re-render the affected containers
 * DIRECTLY. We deliberately do NOT publish the theme's PUB_SUB_EVENTS.cartUpdate
 * event: cart-drawer-items / cart-items listen to it and, for any source other than
 * 'cart-items', re-fetch the cart-PAGE section and inject it into themselves — which
 * corrupts the drawer a moment after the change. Direct re-rendering avoids that.
 */
(function () {
  if (window.__cdcSubUpgradeBound) return;
  window.__cdcSubUpgradeBound = true;

  function parseDoc(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function swapInner(targetEl, sourceEl) {
    if (targetEl && sourceEl) targetEl.innerHTML = sourceEl.innerHTML;
  }

  // One request for every container that might be on the current page; apply each
  // only where its target element actually exists.
  function rerenderCart() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        try {
          if (data['cart-drawer']) {
            var d = parseDoc(data['cart-drawer']);
            swapInner(document.querySelector('#CartDrawer'), d.querySelector('#CartDrawer'));
          }
          if (data['cart-icon-bubble']) {
            var bub = parseDoc(data['cart-icon-bubble']);
            var bubbleEl = document.getElementById('cart-icon-bubble');
            if (bubbleEl) {
              var src = bub.querySelector('.shopify-section') || bub.body;
              var tgt = bubbleEl.querySelector('.shopify-section') || bubbleEl;
              swapInner(tgt, src);
            }
          }
          if (data['main-cart-items']) {
            var mi = parseDoc(data['main-cart-items']);
            var itemsEl = document.getElementById('main-cart-items');
            if (itemsEl) swapInner(itemsEl.querySelector('.js-contents') || itemsEl, mi.querySelector('.js-contents'));
          }
          if (data['main-cart-footer']) {
            var mf = parseDoc(data['main-cart-footer']);
            var footerEl = document.getElementById('main-cart-footer');
            if (footerEl) swapInner(footerEl.querySelector('.js-contents') || footerEl, mf.querySelector('.js-contents'));
          }
        } catch (e) {
          console.warn('[cdc-sub-upgrade] re-render apply failed', e);
        }
        // Benign signal for the gift countdown only — NOT the theme cartUpdate pubsub.
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  function applyUpgrade(btn) {
    var key = btn.getAttribute('data-line-key');
    var planId = btn.getAttribute('data-plan-id');
    var qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
    var isRemove = btn.hasAttribute('data-cdc-sub-remove');
    console.log('[cdc-sub-upgrade] clicked', { key: key, planId: planId, qty: qty, remove: isRemove });

    if (!key) { console.warn('[cdc-sub-upgrade] missing data-line-key'); return; }
    if (!isRemove && (!planId || planId === '0')) { console.warn('[cdc-sub-upgrade] missing/zero data-plan-id'); return; }

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    // selling_plan: null strips the plan from the line (downgrade to one-time)
    var payload = { id: key, quantity: qty, selling_plan: isRemove ? null : parseInt(planId, 10) };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
      })
      .then(function (res) {
        console.log('[cdc-sub-upgrade] /cart/change.js ->', res.status, res.data);
        if (!res.ok || (res.data && res.data.status)) {
          throw new Error((res.data && (res.data.description || res.data.message)) || ('HTTP ' + res.status));
        }
        return rerenderCart();
      })
      .catch(function (err) {
        console.error('[cdc-sub-upgrade] failed:', err);
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        var errEl = document.getElementById('CartDrawer-CartErrors');
        if (errEl) errEl.textContent = 'Could not update subscription: ' + err.message;
      });
  }

  // Capture phase => fires before any bubbling-phase stopPropagation can swallow it.
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = (t && t.closest) ? t.closest('[data-cdc-sub-upgrade], [data-cdc-sub-remove]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    applyUpgrade(btn);
  }, true);

  console.log('[cdc-sub-upgrade] handler ready (asset loaded)');
})();